module.exports = __webpack_public_path__ + "static/uptime-95d48a84ea8b87ada6db50531ade6111.svg";